<template>
    <Tooltip
        v-if="isAdFreeActive"
        :content="badgeRemainigTimeTooltip"
    >
        <div
            :class="$style.button_override"
            @click="adDisabledStore.openDisabledAdModal()"
        >
            <div :class="$style.icon" />
            <Typography
                type="label"
                size="xs"
                :class="$style.number"
                :responsive="false"
                bold
            >
                {{ remainingTime }}
            </Typography>
            <Typography
                type="label"
                size="xs"
                :class="$style.label"
                :responsive="false"
                bold
            >
                {{ remainingLabel }}
            </Typography>
        </div>
    </Tooltip>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import Tooltip from '@/components_new/Tooltip/Tooltip.vue'
import Typography from '@/components_new/Typography.vue'
import { useTr } from '@/composables/use-tr'
import { useAdDisabledStore } from '@/store/ad-disabled-store'

const adDisabledStore = useAdDisabledStore()
const { isAdFreeActive, remainingMsWithoutAd } = storeToRefs(adDisabledStore)
const tr = useTr()

const leftLess10Min = computed(() => remainingMsWithoutAd.value <= 600_000)
const remainingTime = computed(() =>
    leftLess10Min.value
        ? Math.ceil(remainingMsWithoutAd.value / (1000 * 60))
        : Math.ceil(remainingMsWithoutAd.value / (1000 * 60 * 60 * 24)),
)
const remainingLabel = computed(() =>
    leftLess10Min.value ? tr('noAdBadge.minOnly', remainingTime.value) : tr('noAdBadge.daysOnly', remainingTime.value),
)

const badgeRemainigTimeTooltip = computed(() =>
    leftLess10Min.value
        ? tr('noAdBadge.tooltipMin', remainingTime.value)
        : tr('noAdBadge.tooltip', remainingTime.value),
)
</script>

<style module>
.button_override {
    position: relative;
    width: 48px;
    height: 48px;
    flex-shrink: 0;
    border-radius: 1000px;
    background: var(--carbon-400);
    cursor: pointer;
}

.icon {
    width: 48px;
    height: 48px;
    border-radius: 24px;
    background: #2f4312;
    box-shadow: inset 0 0 0 1px rgba(156, 229, 46, 0.25);
    transition: background 0.2s;
}

.button_override:hover .icon {
    background: #51761b;
}

.number {
    position: absolute;
    top: 3px;
    left: 0;
    right: 0;
    color: var(--experimental-salad);
    text-align: center;
    font-size: 21px;
    pointer-events: none;
}

.label {
    position: absolute;
    bottom: 9px;
    left: 0;
    right: 0;
    text-transform: uppercase;
    color: var(--experimental-salad);
    text-align: center;
    font-size: 8px;
    pointer-events: none;
}

@media (--desktop-small-plus) {
    .button_override {
        transition: background 0.3s;
        padding: 4px;
    }

    .button_override:hover,
    .button_override:focus {
        background: var(--experimental-salad);
    }

    .number {
        top: 7px;
    }

    .label {
        bottom: 13px;
    }
}
</style>
